import React, { Component } from 'react'
import { connect } from 'react-redux'
import { TYPE_SENSOR } from 'helpers/environmentMonitor'
import ModuleA from './modules/ModuleA'
import ModuleB from './modules/ModuleB'

class Content extends Component {
  getComponent = type => (type === TYPE_SENSOR ? ModuleB : ModuleA)

  render() {
    const { type } = this.props
    const Component = this.getComponent(type)

    return <Component />
  }
}

export default connect(state => ({
  type: state.getIn(['environment', 'type']),
}))(Content)
